export default __webpack_public_path__ + "static/media/virtuallibrary.5ff4aed1.png";